export default "__VITE_ASSET__3790833c__"